import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  connect() {
    this.refreshAll()
  }

  add(event) {
    event.preventDefault()

    const index = `${Date.now()}${Math.floor(Math.random() * 1000)}`
    const content = this.templateTarget.innerHTML.replaceAll("NEW_PARTICIPANT_RECORD", index)
    this.containerTarget.insertAdjacentHTML("beforeend", content)
    this.refresh(this.containerTarget.lastElementChild)
  }

  remove(event) {
    event.preventDefault()

    const row = event.currentTarget.closest("[data-opportunity-action-participant-row]")
    if (!row) return

    const destroyInput = row.querySelector("[data-opportunity-action-participant-destroy]")
    if (destroyInput) destroyInput.value = "1"

    row.classList.add("d-none")
    row.querySelectorAll("input, select").forEach((field) => {
      if (field !== destroyInput) field.disabled = true
    })
  }

  participantTypeChanged(event) {
    this.refresh(event.target.closest("[data-opportunity-action-participant-row]"))
  }

  refreshAll() {
    this.element
      .querySelectorAll("[data-opportunity-action-participant-row]")
      .forEach((row) => this.refresh(row))
  }

  refresh(row) {
    if (!row || row.classList.contains("d-none")) return

    const kind = row.querySelector("[data-opportunity-action-participant-kind]")?.value
    row.querySelectorAll("[data-opportunity-action-participant-fields]").forEach((section) => {
      const active = section.dataset.opportunityActionParticipantFields === kind
      section.classList.toggle("d-none", !active)
      section.querySelectorAll("input, select").forEach((field) => {
        field.disabled = !active
      })
    })
  }
}
